import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button
} from '@mui/material';
import { ReactComponent as Warning } from 'assets/Warning.svg'; 

const TemplateDownloadModal = ({ open, onClose, onConfirm }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="template-download-warning"
      aria-describedby="template-download-warning-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '40px 10px',
          maxWidth: '500px',
          width: '90%',
          textAlign: 'center',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
          outline: 'none'
        }}
      >
        {/* Failed Icon */}
        
          <Box sx={{ mb: 0 }}>
          <Warning style={{ width: '161px', height: '149px', margin: '0 auto' }} />
        </Box>

        {/* Warning Message */}
        <Typography
          id="template-download-warning-description"
          sx={{
            color: '#333',
            fontSize: '16px',
            lineHeight: 1.5,
            fontFamily:'Montserrat',
            fontWeight:500,
            mb: 4,
            maxWidth: '400px',
             margin: '0 auto'
          }}
        >
          Only data from previously successful uploads will be available for download; users will not be able to view partially successful uploads.
        </Typography>

        {/* OK Button */}
        <Button
          onClick={onConfirm}
          sx={{
            mt:4,
            backgroundColor: '#EF7D00',
            color: 'white',
            borderRadius: '10px',
            padding: '12px 32px',
            fontSize: '16px',
            fontWeight: 'bold',
            minWidth: '100px',
            '&:hover': {
              backgroundColor: '#d66d00'
            },
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
          }}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
};

export default TemplateDownloadModal;
